import { AxiosResponse } from "axios";
import BaseService, { FormField } from "./_base";

interface Page {
  action?: string,
  category: string;
  title: string;
  url: string;
  icon: string;
}

interface PageListResponse {
  sidebar: Page[];
}

class PageService extends BaseService<Page> {
  constructor() {
    super("/api/v2/app/pages/");
    this.cacheTimeout = 60 * 5;
  }

  async navigation(): Promise<AxiosResponse<PageListResponse>> {
    return this._get("navigation/") as unknown as Promise<AxiosResponse<PageListResponse>>;
  }
}

const pageService = new PageService();

export { pageService, Page }
